const { measurePageViewed } = require("./src/utils/openai-ads")

exports.onRouteUpdate = ({ location }) => {
  measurePageViewed(location)
}
